@use '../../../scss/global/spacing';
@use '../../../scss/global/color';

@use './input.mixins' as mixins;
@use './input.vars' as *;

:host {
  display: flex;
  flex-direction: column;
  gap: spacing.$spacer-1;

  @include mixins.input-text;
  @include mixins.header;
  @include mixins.input;

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
}

@include mixins.input-disabled;
